<template>
  <div :class="$style.root">
    <LayoutPageHeaderComponent
      :data="localizedData"
      :class="$style.header"
    />

      <div :class="$style.content">
      <div class="container--default">
        <CoreImageSliderComponent
          v-if="localizedData?.images"
          :images="localizedData?.images?.data"
        />
      </div>

      <ul :class="$style.sections">
        <li
          v-for="section in localizedData?.sections"
        >
          <ul :class="$style.section">
            <li :class="$style['section-label']">
              {{ getLabel(section) }}
            </li>
            <li
              v-for="item in section?.items"
              :class="$style['section-item']"
            >
              <div>
                {{ getLabel(item) }}
              </div>
              <CoreTextComponent
                v-if="getText(item)"
                :string="getText(item)"
                :class="$style['section-item-text']"
              />
            </li>
          </ul>
        </li>
      </ul>

      <a
        :href="localizedData?.tickets_url"
        target="_blank"
        v-if="localizedData?.tickets_url"
        rel="noopener noreferrer"
        :class="$style.tickets"
      >
        {{ $t('tickets.buy_online') }}
      </a>
    </div>
  </div>
</template>

<script setup>
const { locale: currentLocale, locales } = useI18n()

const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const getLabel = (section) => {
  return currentLocale.value === 'en' ? section?.i18n_string_en : section?.i18n_string_al
}

const getText = (item) => {
  return currentLocale.value === 'en' ? item?.i18n_richtext_en : item?.i18n_richtext_al
}

</script>

<style module>
.content {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);
}

.header {
  margin-bottom: 0;
}

.sections {
  composes: reset-list container--default from global;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);
}

.section {
  composes: reset-list from global;
}

.section-label {
  text-transform: uppercase;
  border-bottom: var(--stroke--default) solid;
  padding-bottom: var(--unit--spacer);
  margin-bottom: var(--unit--spacer);
}

.section-item {
  composes: font-size-small from global;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: calc(var(--unit--horizontal) * 1);

  padding-bottom: var(--unit--spacer);
}

.tickets {
  composes: reset-link link-box from global;
  margin: auto;
}

</style>
